import { render, staticRenderFns } from "./ExerciseScore.vue?vue&type=template&id=67b8e91b&scoped=true"
import script from "./ExerciseScore.vue?vue&type=script&lang=js"
export * from "./ExerciseScore.vue?vue&type=script&lang=js"
import style0 from "./ExerciseScore.vue?vue&type=style&index=0&id=67b8e91b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b8e91b",
  null
  
)

export default component.exports